import { formatHighestByValueAndSorts, filterSelectedOptions } from '../utils';
import { MeterOptions } from '../types';

export const useMeterFormatData = (options: MeterOptions[], selectedOptions?: string[]) => {
  const filteredOptions = selectedOptions
    ? filterSelectedOptions(options, selectedOptions)
    : options;
  const meterBarData = formatHighestByValueAndSorts(filteredOptions);
  const totalValue = options.reduce((acc, { value }) => acc + value, 0);

  return {
    meterBarData,
    totalValue,
  };
};
